import Button from "@components/ui/Button";
import Input from "@components/ui/Input";

export default function AdminClinicsHeader({ onBack, query, onQueryChange }) {
  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex items-center gap-3">
        <Button color="light" onClick={onBack}>
          ← Back
        </Button>
        <div>
          <h1 className="text-lg sm:text-xl font-semibold">Admin: Clinics</h1>
          <p className="text-xs sm:text-sm text-gray-500">
            View clinics in the list and edit in a clean form.
          </p>
        </div>
      </div>

      <div className="w-full sm:w-[360px]">
        <Input
          placeholder="Search clinics…"
          value={query}
          onChange={(e) => onQueryChange(e.target.value)}
        />
      </div>
    </div>
  );
}
